import React from 'react';
import PropTypes from 'prop-types';
import './masterBar.scss';
import { useContextMatchParams } from 'contexts/matchParams';
import { useContextProperties } from 'contexts/properties';

const MasterBarGeneral = ({ onClick }) => {
  const { matchParams } = useContextMatchParams();

  const { showMasterBar, subtype } = matchParams;

  const { params } = useContextProperties();

  const isOpenedTabs = Number(showMasterBar);

  const { elections } = params;

  // Módelo solo para la cabecera génerica (Versión móvil y desktop distintas)
  return (
    <header className="masterBar">
      <h2 className="masterBarTitle masterBarTitle--mobile">
        {isOpenedTabs ? elections.titleRegularMobile : elections.titleRegular}{' '}
        <strong>{elections.titleStrong}</strong>
      </h2>
      <h2 className="masterBarTitle masterBarTitle--desktop">
        {elections.titleRegular} <strong>{elections.titleStrong}</strong>
      </h2>
      {elections.types && elections.types.length > 0 && isOpenedTabs ? (
        <nav className="masterBarButtonsContainer">
          <ul className="masterBarButtons">
            <li
              className={`masterBarButton ${
                subtype === 'CONGRESS' ? `current` : ''
              }`}
              onClick={e => onClick(e, 'CONGRESS')}
            >
              <a href="election.paths[site]" target="_parent" rel="noreferrer">
                CONGRESO
              </a>
            </li>
            <li
              className={`masterBarButton ${
                subtype === 'SENATE' ? `current` : ''
              }`}
              onClick={e => onClick(e, 'SENATE')}
            >
              <a href="election.paths[site]" target="_parent" rel="noreferrer">
                SENADO
              </a>
            </li>
          </ul>
        </nav>
      ) : null}
    </header>
  );
};

MasterBarGeneral.propTypes = {
  onClick: PropTypes.func.isRequired
};

export default MasterBarGeneral;
